'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Get Cost-Effective Enterprise-Grade Tailored Solutions by Hiring Magento Certified Developers at Moweb"
                alt="Magento Development"
                title="Magento Development"
                width={1090}
                height={604}
                path={'magento-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                Magento <div>Development Company</div>
            </TechHero>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Magento" />
            <ContetVideoSection title="Unlock Online Shopping Portal for Your Business with The Power of Magento">
                <>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Recognized highly for building e-commerce websites, Magento is an open-source e-commerce platform written
                        in PHP. It is preloaded with scores of features and specifications needed to build functional e-commerce
                        websites. Having an open architecture system, help developers to create a unique and appealing user
                        experience that corresponds to the different type of device access. Its specifications like multi-tenant
                        feature, easy third-party integrations, SEO-friendly, and m-commerce support makes Magento e-commerce
                        website development a reliable and supreme choice for startups, business, and big enterprises.
                    </p>
                </>
            </ContetVideoSection>
            <HireProcess
                bg="bg-magento"
                pageTitle="Hire Magneto Developers To Build Cutting-Edge Digital Products"
                desc="These strategies when turned into appealing user experiences are brought to life with robust engineering and cutting-edge skills, calls for an expert Magento developer."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For Magento Web Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Magento Developers"
                desc="Select from different engagement models to hire Django Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
